import {FormDefinitionFormModel} from "../formDefinitionForm.model";
import {FormDefinitionFormSummaryConverter} from "./formDefinitionFormSummary.converter";
import {HttpModelConverter} from "../../../../../../core/converter/httpModel.converter";
import {FormDefinitionGroupConverter} from "../../../../group/api/entity/converter/formDefinitionGroup.converter";
import {Injectable} from "@angular/core";
import {FormDefinitionFormFieldConverter} from "./formDefinitionFormField.converter";

@Injectable({
    providedIn: 'root'
})
export class FormDefinitionFormConverter extends HttpModelConverter<FormDefinitionFormModel> {

    constructor(private groupConverter: FormDefinitionGroupConverter,
                private fieldConverter: FormDefinitionFormFieldConverter) {
        super();
    }

    protected createInstance(): FormDefinitionFormModel {
        return new FormDefinitionFormModel();
    }

    protected enrichObject(result: FormDefinitionFormModel, src: FormDefinitionFormModel) {
        result.summary = new FormDefinitionFormSummaryConverter().convert(src.summary);
        result.groups = this.groupConverter.convertFromArray(src.groups);
        result.fields = this.fieldConverter.convertFromArray(src.fields);
    }

}